import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient, ApiClientWithAuth } from './client'
import { SessionApiErrorResponse } from './session/response'

const namespace = 'session-api'

export class SessionApiService {
  constructor(
    private readonly apiClient: typeof ApiClient = ApiClient,
    private readonly apiClientWithAuth: typeof ApiClientWithAuth = ApiClientWithAuth
  ) {}

  /**
   * セッションの同期（有効なら延長、無ければ新規作成）
   * keep/newの分岐はリクエストのcookieを観測できるserver側の責務（issue #9104）
   */
  async sync(context: SyncSessionContext): Promise<Either<SessionApiErrorResponse, undefined>> {
    try {
      const response = await this.apiClient.post('/api/user/session/sync', {
        is_hl_app: context.isHlApp,
      })

      log.debug({ service: `${namespace}/sync`, response })

      return new Right(undefined)
    } catch (error) {
      log.error({ service: `${namespace}/sync`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }

  /**
   * セッションデータを更新する
   */
  async loadData(): Promise<Either<SessionApiErrorResponse, undefined>> {
    try {
      const response = await this.apiClientWithAuth.put('/api/user/session/current/data')

      log.debug({ service: `${namespace}/loadData`, response })

      return new Right(undefined)
    } catch (error) {
      log.error({ service: `${namespace}/loadData`, error })
      const response = (error as any).response

      return new Left(response
        ? SessionApiErrorResponse.fromResponse(response)
        : SessionApiErrorResponse.fromString(error instanceof Error ? error.message : String(error))
      )
    }
  }
}

export interface SyncSessionContext {
  isHlApp: boolean
}
